export default [
    {
        path: "customers-tab",
        name: "CustomersTab",
        meta: {
            permissionPath: "customers.read"
        },
        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/views/loyaltyPanel/customers/tabs/CustomersTab.vue"
            )
    },
    {
        path: "attributes-tab",
        name: "AttributesTab",
        meta: {
            permissionPath: "customers.read"
        },
        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/views/loyaltyPanel/customers/tabs/AttributesTab.vue"
            )
    },

    {
        path: "notifications-tab",
        name: "NotificationsTab",
        meta: {
            permissionPath: "customers.read"
        },
        component: () =>
            import(
                /* webpackChunkName: "customers" */ "@/views/loyaltyPanel/customers/tabs/NotificationsTab.vue"
            )
    }
];
